import { registerDialog, unregisterDialog, dialogs } from '../helpers';
export const register = (modalType, Component) => {
    if (dialogs.has(modalType)) {
        throw new Error(`Dialog with type "${modalType}" was already registered`);
    }
    registerDialog(modalType, Component);
};
export const unregister = (modalType) => {
    unregisterDialog(modalType);
};
